import React, { useState, useEffect, Fragment } from "react";
import logo from "../../../assets/images/endless-logo.png";
import Language from "./language";
import { BrushIcon } from "../../../assets/icons8_paint_brush.svg";
import { CalculatorIcon } from "../../../assets/icons8_Calculator.svg";
import UserMenu from "./userMenu";
import Notification from "./notification";
import SearchHeader from "./searchHeader";
import styled from "styled-components";
import { RiCalculatorFill } from "react-icons/ri";
import FixedPlugin from "components/shareRegistrar/instantCalculator/instantCalculator";
import { Link } from "react-router-dom";
import {
  AlignLeft,
  Maximize,
  Bell,
  MessageCircle,
  MoreHorizontal,
} from "react-feather";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { EN } from "../../../constant";
import { getCompanies } from "store/services/company.service";
import { darkStyle, darkStyle2, errorStyles } from "components/defaultStyles";
import Select from "react-select";
import { AiOutlineClose } from "react-icons/ai";
import { useHistory } from "react-router";
import { useSelector } from "react-redux";
import ThemeCustomizer from "../theme-customizer";

// import { VscRobot } from "react-icons/vsc";

const Header = () => {
  // const history = useHistory();
  const mixLayout = useSelector((state) => state?.Customizer?.mix_layout);
  const [openCustomizer, setOpenCustomizer] = useState(false);
  const [openThemeRightSidebar, setOpenThemeRightSidebar] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [sidebar1, setSidebar1] = useState(false);
  const baseEmail = sessionStorage.getItem("email") || "";
  const [rightSidebar, setRightSidebar] = useState(true);
  const [headerbar, setHeaderbar] = useState(true);
  const [selectCompanyModal, setSelectCompanyModal] = useState(false);
  const [calculatorFlag, setCalculatorFlag] = useState(false);
  const [openCalculator, setOpenCalculator] = useState(false);
  const [history, setHistory] = useState(false);
  const [search, setSearch] = useState("");
  const [mainAllCompaniesData, setMainAllCompaniesData] = useState();
  const [mainCompaniesDropdown, setMainCompaniesDropdown] = useState([]);
  const [mainCompaniesDataLoading, setMainCompaniesDataLoading] =
    useState(false);
  const [mainSelectedCompany, setMainSelectedCompany] = useState(
    sessionStorage.getItem("mainSelectedCompany") &&
      sessionStorage.getItem("mainSelectedCompany") !== ""
      ? JSON.parse(sessionStorage.getItem("mainSelectedCompany"))
      : undefined
  );
  // Worked out from the search text on every render, so once the search is cleared
  // (closing the modal, picking a company) the full list is shown again. Selected company first.
  const searchTerm = search.trim().toLowerCase();
  const matchingCompanies = mainCompaniesDropdown.filter((item) =>
    item.label.toLowerCase().includes(searchTerm)
  );
  const filteredItems = [
    ...matchingCompanies.filter((c) => c.value === mainSelectedCompany?.value),
    ...matchingCompanies.filter((c) => c.value !== mainSelectedCompany?.value),
  ];

  useEffect(() => {
    // sessionStorage.removeItem("menu_tab");
    const getAllCompanies = async () => {
      setMainCompaniesDataLoading(true);
      try {
        const response = await getCompanies(baseEmail);
        if (response.status === 200) {
          response.data.data = response.data.data.filter(
            (item) => item?.active === "Y"
          );
          const parents = response.data.data;
          setMainAllCompaniesData(parents);
          const companies_dropdowns = response.data.data.map((item) => {
            let label = `${item.company_name}`;
            let logo = item?.logo ? item?.logo : "";
            return { label: label, value: item.code, logo: logo };
          });
          setMainCompaniesDropdown(companies_dropdowns);
          setMainCompaniesDataLoading(false);
        }
      } catch (error) {
        setMainCompaniesDataLoading(false);
      }
    };
    getAllCompanies();
  }, []);



  useEffect(() => {
    if (
      mainSelectedCompany
      // && mainSelectedCompany.trim() !== ""
    ) {
      sessionStorage.setItem(
        "mainSelectedCompany",
        JSON.stringify(mainSelectedCompany)
      );

      window.dispatchEvent(new Event("storage"));
    } else if (!mainSelectedCompany) {
      sessionStorage.setItem("mainSelectedCompany", "");

      window.dispatchEvent(new Event("storage"));
    }
  }, [mainSelectedCompany]);

  const openCloseSidebar = () => {
    if (document.documentElement.clientWidth <= 768) {

      if (sidebar || sessionStorage.getItem("menu") == "true") {

        setSidebar1(true);
        setSidebar(!sidebar);
        document.querySelector(".page-main-header").classList.toggle("open");
        document.querySelector(".page-sidebar").classList.toggle("open");
        sessionStorage.removeItem("menu");
      } else if (sidebar === false || sessionStorage.getItem("menu") == null) {


        setSidebar1(false);
        setSidebar(!sidebar);
        document.querySelector(".page-main-header").classList.toggle("open");
        document.querySelector(".page-sidebar").classList.toggle("open");
      }
    } else {


      setSidebar1(false);
      if (sidebar) {

        setSidebar(!sidebar);
        document.querySelector(".page-main-header").classList.remove("open");
        document.querySelector(".page-sidebar").classList.remove("open");
        // sessionStorage.setItem('menu_tab',false);
      } else {

        setSidebar(!sidebar);
        document.querySelector(".page-main-header").classList.add("open");
        document.querySelector(".page-sidebar").classList.add("open");
        // sessionStorage.setItem('menu_tab',true);
      }
    }
  };

  function showRightSidebar() {
    if (rightSidebar) {
      setRightSidebar(!rightSidebar);
      document.querySelector(".right-sidebar").classList.add("show");
    } else {
      setRightSidebar(!rightSidebar);
      document.querySelector(".right-sidebar").classList.remove("show");
    }
  }

  //full screen function
  function goFull() {
    if (
      (document.fullScreenElement && document.fullScreenElement !== null) ||
      (!document.mozFullScreen && !document.webkitIsFullScreen)
    ) {
      if (document.documentElement.requestFullScreen) {
        document.documentElement.requestFullScreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        document.documentElement.webkitRequestFullScreen(
          Element.ALLOW_KEYBOARD_INPUT
        );
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const handleCompanySearch = (e) => setSearch(e.target.value);

  const WrapperResponsive = styled.div`
    @media (max-width: 500px) {
      .company-name {
        display: none !important;
      }
      .company-div {
        overflow: visible;
      }
      // .company-onSmall{
      //   width:35% !important
      // }
    }
    @media (min-width: 991px) {
      .hide-onLarge {
        display: none !important;
      }
    }
    @media (max-width: 991px) {
      .ontab-Margin {
        margin-right: 0px !important;
      }
      .onbelow-Tab {
        justify-content: center;
      }
      .company-name {
        display: none !important;
      }
    }
  `;

  const [screen, setScreen] = useState();
  useEffect(() => {
    const handleResize = () => {
      setScreen(window?.outerWidth);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const dividerStyle =
    mixLayout == "dark-only" || mixLayout == "dark-header-sidebar-mix"
      ? "#374558 "
      : "#eff0f1";

  return (
    <Fragment>
      {openThemeRightSidebar && (
        <ThemeCustomizer
          setOpenThemeRightSidebar={setOpenThemeRightSidebar}
          Customizer={openCustomizer}
          setCustomizer={setOpenCustomizer}
        />
      )}

      <div className="page-main-header">
        {/* -------- Join Online Modal start ------- */}

        <Modal
          toggle={() => {
            setSearch("");
            setSelectCompanyModal(false);
          }}
          centered={true} isOpen={selectCompanyModal} size="lg">
          <ModalHeader
            toggle={() => {
              setSearch("");
              setSelectCompanyModal(false);
            }}
          >
            Select Company
          </ModalHeader>
          <ModalBody
            style={{
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {/* {mainSelectedCompany && (
              <div className="row d-flex flex-row align-content-center justify-content-center">
                <p className="mx-3">
                  <b>Current Company: </b> {mainSelectedCompany?.label}
                </p>
                <AiOutlineClose
                  id="cancelauthorized"
                  style={{ cursor: "pointer", color: "red" }}
                  onClick={() => {
                    setSearch("");
                    setFilteredItems(mainCompaniesDropdown);
                    setMainSelectedCompany(undefined);
                    sessionStorage.removeItem("mainSelectedCompany");
                  }}
                  className="mt-1"
                />
              </div>
            )} */}

            {/* {!mainSelectedCompany && ( */}
            <>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%" }}
              >
                <input
                  id="searchTransaction"
                  style={{ width: "100%" }}
                  className="form-control mb-3 col-md-6 col-sm-12"
                  type="text"
                  placeholder={"Search Company"}
                  value={search}
                  onChange={(e) => handleCompanySearch(e)}
                // onKeyPress={handleKeypress}
                />
              </div>
              <hr></hr>

              <div class="list-group">
                {filteredItems && filteredItems.length > 0 ? (
                  filteredItems?.map((item) => {
                    return (
                      <button
                        style={{
                          minHeight: "65px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setMainSelectedCompany(item || undefined);
                          setSearch("");
                          setSelectCompanyModal(false);
                        }}
                        type="button"
                        aria-current="true"
                        className={
                          mainSelectedCompany?.value == item?.value
                            ? " list-group-item list-group-item-action active"
                            : " list-group-item list-group-item-action "
                        }
                      >
                        <div className="d-flex align-items-center">
                          {item?.logo ? (
                            <>
                              <img
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "contain",
                                  objectPosition: "center",
                                }}
                                src={item?.logo}
                              />{" "}
                            </>
                          ) : (
                            <>
                              <div style={{ width: "50px", height: "40px" }} />
                            </>
                          )}
                          {`${item?.label}`}
                        </div>
                      </button>
                    );
                  })
                ) : (
                  <div>
                    {" "}
                    <p>No companies data found!</p>
                  </div>
                )}
                {/* // mainCompaniesDropdown?.map((item) => {
                //     return (
                //       <button
                //         style={{
                //           minHeight: "65px",
                //           cursor: "pointer",
                //         }}
                //         onClick={() => {
                //           item && setMainSelectedCompany(item);
                //           !item && setMainSelectedCompany();
                //           setSelectCompanyModal(false);
                //         }}
                //         type="button"
                //         aria-current="true"
                //         className={
                //           mainSelectedCompany?.value == item?.value
                //             ? " list-group-item list-group-item-action active"
                //             : " list-group-item list-group-item-action "
                //         }
                //       >
                //         <div className="d-flex align-items-center">
                //           {item?.logo ? (
                //             <>
                //               <img
                //                 style={{
                //                   width: "40px",
                //                   height: "40px",
                //                   objectFit: "contain",
                //                   objectPosition: "center",
                //                 }}
                //                 src={item?.logo}
                //               />{" "}
                //             </>
                //           ) : (
                //             <>
                //               <div style={{ width: "50px", height: "40px" }} />
                //             </>
                //           )}
                //           {`${item?.label}`}
                //         </div>
                //       </button>
                //     );
                //   })} */}
              </div>
            </>
            {/* )} */}
          </ModalBody>
        </Modal>

        <div className="main-header-right row position-realtive">
          <WrapperResponsive>
            <div
              className=" hide-onLarge d-flex justify-content-center"
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: "60%",
              }}
            >
              <div className="d-flex align-items-center text-truncate">
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() => setSelectCompanyModal(true)}
                  className="d-flex align-items-center text-truncate"
                >
                  {mainSelectedCompany && mainSelectedCompany?.logo ? (
                    <img
                      className="mr-2"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain",
                        objectPosition: "center",
                      }}
                      src={mainSelectedCompany?.logo}
                    />
                  ) : (
                    <i
                      style={{
                        fontSize: "18px",
                        // fontSize: "24px",
                        color: localStorage.getItem("primary_color"),
                      }}
                      class="icon-package mr-2"
                    ></i>
                  )}

                  <p
                    data-toggle="tooltip"
                    data-placement="top"
                    title={mainSelectedCompany?.label}
                    className="mb-0 text-truncate"
                    style={{ color: localStorage.getItem("primary_color") }}
                  >
                    {mainSelectedCompany && mainSelectedCompany?.label
                      ? mainSelectedCompany?.label
                      : "Select Company"}
                  </p>
                </div>
              </div>
            </div>
          </WrapperResponsive>
          <div className="main-header-left d-lg-none">
            <div className="logo-wrapper">
              <Link to={`/dashboard/default`}>
                {/* <img className="img-fluid" src={logo} alt="" /> */}
              </Link>
            </div>
          </div>
          <div className="mobile-sidebar d-block">
            <div className="media-body text-right switch-sm">
              <label className="switch">
                <a
                  href="#javascript"
                  onClick={() => {
                    setSidebar1(true);
                    openCloseSidebar();
                  }}
                >
                  <AlignLeft />
                </a>
              </label>
            </div>
          </div>
          <div className="nav-right col p-0">
            <ul className={`nav-menus ${headerbar ? "" : "open"}`}>
              {/* <li className="w-50">
                <SearchHeader />
              </li> */}
              <li
                className="company-onSmall mt-2"
                style={{
                  // width: "25%",
                  textAlign: "left",
                  margin: "0 auto 0 0",
                }}
              >
                <WrapperResponsive>
                  <div className="d-flex align-items-center">
                    <div
                      style={{ cursor: "pointer" }}
                      onClick={() => setSelectCompanyModal(true)}
                      className="d-flex align-items-center text-truncate company-div"
                    >
                      {mainSelectedCompany?.logo ? (
                        <img
                          className="mr-2"
                          style={{
                            width: "40px",
                            height: "40px",
                            objectFit: "contain",
                            objectPosition: "center",
                          }}
                          src={mainSelectedCompany?.logo}
                        />
                      ) : (
                        <i
                          style={{
                            fontSize: "24px",
                            // fontSize: screen >= 992 ? "24px" : "18px",
                            color: localStorage.getItem("primary_color"),
                          }}
                          class="icon-package mr-2"
                        ></i>
                      )}

                      <p
                        data-toggle="tooltip"
                        data-placement="top"
                        title={mainSelectedCompany?.label}
                        className="mb-0 text-truncate company-name"
                        style={{
                          fontSize: "24px",
                          color: localStorage.getItem("primary_color"),
                        }}
                      // style={{ fontSize: screen >= 992 ? "24px" : "15px" }}
                      >
                        {mainSelectedCompany?.label
                          ? mainSelectedCompany?.label
                          : "Select Company"}
                      </p>
                    </div>
                  </div>
                </WrapperResponsive>
              </li>
              <li>
                <a onClick={goFull} className="text-dark" href="#!">
                  <Maximize />
                </a>
              </li>
              {/* <li className="onhover-dropdown">
                <a className="txt-dark" href="#javascript">
                  <h6>{EN}</h6></a>
                <Language />
              </li> */}

              {/* NOTIFICATIONS */}

              {/* <li className="onhover-dropdown">
                <Notification />
                <Bell />
                <span className="dot"></span>
                <Notification />
              </li> */}

              {screen > 575 && (
                <li
                  style={{
                    borderLeft: `1px solid ${dividerStyle}`,
                    paddingLeft: "20px",
                  }}
                  className="onhover-dropdown"
                >
                  <svg
                    style={{
                      cursor: "pointer",
                      fontSize: "19px",
                    }}
                    onClick={() => {
                      setOpenCustomizer(true);
                      setOpenThemeRightSidebar(!openThemeRightSidebar);
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 50 50"
                  >
                    <path
                      fill={localStorage?.getItem("primary_color")}
                      stroke={localStorage?.getItem("primary_color")}
                      strokeWidth="2"
                      d="M31.156-.063l-.718.72L24.5 6.624l-.031.031-6.188 6.157a.472.472 0 00-.062.062l-.063.031v.031l-6.031 6.032a.998.998 0 00-.219 1.093s.93 2.149 1.625 4.5c.348 1.176.637 2.403.719 3.375.082.973-.125 1.594-.219 1.688-1.687 1.688-3.344 2.473-4.969 3.156-1.624.684-3.265 1.266-4.593 2.594-1.942 1.941-3.371 4.398-4.032 6.781-.66 2.383-.574 4.832 1 6.407 1.579 1.578 4.024 1.66 6.407 1 2.383-.66 4.84-2.094 6.781-4.032 1.328-1.328 2.195-3.234 3.063-5.062.867-1.828 1.761-3.574 2.687-4.5.234-.235.871-.442 1.844-.375.972.066 2.164.351 3.312.718a35.19 35.19 0 014.344 1.75c.387.192.852.118 1.156-.187l6.032-6.031a.472.472 0 00.062-.063l7.75-7.75.156-.125c.074-.074.137-.156.188-.25l4.125-4.093.718-.72-.718-.687-17.5-17.5zm-.031 2.813L47.25 18.875l-3.469 3.469a.954.954 0 00-.156.125c.008-.008-.277.254-.625.468-.348.215-.8.422-1.25.594-.45.172-.887.285-1.219.282-.293-.004-.449-.07-.593-.188-.004-.031-.024-.11 0-.281.046-.344.195-.887.343-1.469.149-.582.285-1.21.282-1.906-.004-.696-.215-1.496-.813-2.094-.594-.594-1.379-.816-2.063-.813-.683.004-1.312.172-1.874.313-.563.14-1.067.266-1.407.281-.34.016-.402-.027-.5-.125-.504-.504-.668-1.066-.156-2.281.3-.715.813-1.832 1.125-2.938.156-.554.273-1.097.281-1.656.008-.558-.093-1.187-.593-1.687-.434-.434-1.043-.614-1.563-.625-.52-.012-1.008.09-1.5.25-.98.324-1.957.883-2.781 1.406-.418.266-1.203.668-1.907.844-.703.176-1.152.097-1.375-.125-.585-.586-.519-.953-.343-1.469.176-.516.625-1.031.781-1.188A.954.954 0 0026 7.907c.023-.031.043-.062.063-.093zm1.844 7.594c.148.004.148.023.156.031.008.035.035.113.031.25-.004.273-.09.7-.218 1.156-.258.914-.723 1.953-1.032 2.688-.71 1.683-.484 3.386.594 4.469.578.578 1.379.75 2.031.718.653-.031 1.235-.207 1.782-.343.546-.137 1.027-.247 1.374-.25.348-.004.493.054.657.218.16.16.215.32.218.688.004.367-.082.867-.218 1.406-.137.54-.328 1.102-.407 1.688-.078.585-.085 1.351.5 1.937.528.527 1.227.738 1.876.781l-3.938 3.938-16.094-16.094 2.875-2.906c.153.5.438 1 .875 1.437.934.934 2.258.88 3.282.625 1.023-.254 1.925-.726 2.5-1.094.742-.472 1.609-.957 2.312-1.187.352-.117.668-.16.844-.156zm-14.094 4.719l16.063 16.062L30.093 36c-.512-.246-1.832-.922-3.938-1.594-1.238-.394-2.57-.73-3.812-.812-1.242-.082-2.512.074-3.407.968-1.328 1.329-2.164 3.204-3.03 5.032-.868 1.828-1.759 3.601-2.688 4.531-1.684 1.684-3.91 2.95-5.906 3.5-1.997.55-3.598.34-4.438-.5-.836-.84-1.05-2.445-.5-4.438.55-1.992 1.816-4.222 3.5-5.906.926-.93 2.281-1.445 3.969-2.156 1.687-.71 3.656-1.625 5.594-3.563.867-.867.914-2.074.812-3.28-.102-1.208-.41-2.532-.781-3.782-.64-2.16-1.29-3.566-1.5-4.063zM7 41a1.999 1.999 0 100 4 1.999 1.999 0 100-4z"
                    ></path>
                  </svg>
                  {/* <i
                    style={{
                      color: localStorage?.getItem("primary_color"),
                      cursor: "pointer",
                      fontSize: "19px",
                    }}
                    className="icofont icofont-ui-settings"
                    onClick={() => {
                      setOpenCustomizer(true);
                      setOpenThemeRightSidebar(!openThemeRightSidebar);
                    }}
                  ></i> */}
                </li>
              )}
              <li style={{ paddingLeft: "20px" }}>
                <a
                  href="#pablo"
                  onClick={(e) => {
                    e.preventDefault();
                    setHistory(false);
                    setOpenCalculator(true);
                  }}
                >
                  <svg
                    onClick={() => setCalculatorFlag(!calculatorFlag)}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill={localStorage?.getItem("primary_color")}
                      stroke={localStorage?.getItem("primary_color")}
                      strokeWidth="1"
                      d="M13.5 4C10.48 4 8 6.48 8 9.5v29c0 3.02 2.48 5.5 5.5 5.5h21c3.02 0 5.5-2.48 5.5-5.5v-29C40 6.48 37.52 4 34.5 4h-21zm0 3h21C35.898 7 37 8.102 37 9.5v29c0 1.398-1.102 2.5-2.5 2.5h-21a2.478 2.478 0 01-2.5-2.5v-29C11 8.102 12.102 7 13.5 7zm2.96 3.998c-1.34 0-2.46 1.122-2.46 2.463v6.078C14 20.88 15.12 22 16.46 22h15.08c1.34 0 2.46-1.12 2.462-2.459v-6.08c0-1.34-1.122-2.463-2.463-2.463H16.461zm.54 3h14.002V19H17v-5.002zM16.5 25a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 00-2.5 2.5v7a2.5 2.5 0 105 0v-7a2.5 2.5 0 00-2.5-2.5zm-15 7a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"
                    ></path>
                  </svg>
                  {/* <svg
                    onClick={() => setCalculatorFlag(!calculatorFlag)}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                  >
                    <path fill={localStorage?.getItem("primary_color")} stroke={localStorage?.getItem("primary_color")} strokeWidth="1" d="M13.5 4C10.48 4 8 6.48 8 9.5v29c0 3.02 2.48 5.5 5.5 5.5h21c3.02 0 5.5-2.48 5.5-5.5v-29C40 6.48 37.52 4 34.5 4h-21zm0 3h21C35.898 7 37 8.102 37 9.5v29c0 1.398-1.102 2.5-2.5 2.5h-21a2.478 2.478 0 01-2.5-2.5v-29C11 8.102 12.102 7 13.5 7zm2.96 3.998c-1.34 0-2.46 1.122-2.46 2.463v6.078C14 20.88 15.12 22 16.46 22h15.08c1.34 0 2.46-1.12 2.462-2.459v-6.08c0-1.34-1.122-2.463-2.463-2.463H16.461zm.54 3h14.002V19H17v-5.002zM16.5 25a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 00-2.5 2.5v7a2.5 2.5 0 105 0v-7a2.5 2.5 0 00-2.5-2.5zm-15 7a2.5 2.5 0 000 5 2.5 2.5 0 000-5zm7.5 0a2.5 2.5 0 000 5 2.5 2.5 0 000-5z"></path>
                  </svg> */}
                  {/* <svg
                    onClick={() => setCalculatorFlag(!calculatorFlag)}
                    style={{
                      fontSize: "19px",
                    }}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 128 128">
                    <path fill={localStorage?.getItem("primary_color")} stroke={localStorage?.getItem("primary_color")} strokeWidth="3" d="M24 1C11.32 1 1 11.32 1 24v80c0 12.68 10.32 23 23 23h80c12.68 0 23-10.32 23-23V24c0-12.68-10.32-23-23-23H24zm0 6h80c9.37 0 17 7.63 17 17v80c0 9.37-7.63 17-17 17H24c-9.37 0-17-7.63-17-17V24c0-9.37 7.63-17 17-17zm5 24c-1.66 0-3 1.34-3 3s1.34 3 3 3h70c1.66 0 3-1.34 3-3s-1.34-3-3-3H29zm-5 21c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V60c0-4.41-3.59-8-8-8H24zm35 0c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V60c0-4.41-3.59-8-8-8H59zm35 0c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V60c0-4.41-3.59-8-8-8H94zm-70 6h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H24c-1.1 0-2-.9-2-2V60c0-1.1.9-2 2-2zm35 0h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H59c-1.1 0-2-.9-2-2V60c0-1.1.9-2 2-2zm35 0h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H94c-1.1 0-2-.9-2-2V60c0-1.1.9-2 2-2zM24 87c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V95c0-4.41-3.59-8-8-8H24zm35 0c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V95c0-4.41-3.59-8-8-8H59zm35 0c-4.41 0-8 3.59-8 8v10c0 4.41 3.59 8 8 8h10c4.41 0 8-3.59 8-8V95c0-4.41-3.59-8-8-8H94zm-70 6h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H24c-1.1 0-2-.9-2-2V95c0-1.1.9-2 2-2zm35 0h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H59c-1.1 0-2-.9-2-2V95c0-1.1.9-2 2-2zm35 0h10c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H94c-1.1 0-2-.9-2-2V95c0-1.1.9-2 2-2z"></path>
                  </svg> */}
                  {/* <RiCalculatorFill
                    color="primary"
                    size={43}
                    onClick={() => setCalculatorFlag(!calculatorFlag)}
                  /> */}
                </a>
              </li>
              {/* AI SEARCH */}
              {/* <li
                onClick={() => history.push("/search-listing")}
                style={{
                  marginBottom: screen >= 992 ? "3px" : "10px",
                  marginTop: screen >= 992 ? "" : "10px",
                  cursor: "pointer",
                }}
              >
           
                <svg
                  style={{
                    width: "23px",
                    height: "23px",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill={localStorage.getItem("primary_color")}
                    d="M12 2a2 2 0 00-2 2 2 2 0 001 1.73V8H8c-2.197 0-4 1.803-4 4v4H2v2h2v2c0 1.093.907 2 2 2h12c1.093 0 2-.907 2-2v-2h2v-2h-2v-4c0-2.197-1.803-4-4-4h-3V5.729A2 2 0 0014 4a2 2 0 00-2-2zm-4 8h8c1.117 0 2 .883 2 2v8h-3v-2H9v2H6v-8c0-1.117.883-2 2-2zm1.5 3A1.5 1.5 0 008 14.5 1.5 1.5 0 009.5 16a1.5 1.5 0 001.5-1.5A1.5 1.5 0 009.5 13zm5 0a1.5 1.5 0 00-1.5 1.5 1.5 1.5 0 001.5 1.5 1.5 1.5 0 001.5-1.5 1.5 1.5 0 00-1.5-1.5z"
                  ></path>
                </svg>
              
              </li> */}
              {/* <li>
                <a href="#javascript" onClick={showRightSidebar}>
                  <MessageCircle />
                  <span className="dot"></span>
                </a>
              </li> */}
              <UserMenu />
            </ul>
            <div
              className="d-lg-none mobile-toggle pull-right"
              onClick={() => {
                setSidebar1(false);
                setSidebar(!sidebar);
                document.querySelector(".page-sidebar").classList.add("open");
                setHeaderbar(!headerbar);
              }}
            >
              <MoreHorizontal />
            </div>
          </div>
          <script id="result-template" type="text/x-handlebars-template">
            <div className="ProfileCard u-cf">
              <div className="ProfileCard-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="feather feather-airplay m-0"
                >
                  <path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path>
                  <polygon points="12 15 17 21 7 21 12 15"></polygon>
                </svg>
              </div>
              <div className="ProfileCard-details">
                <div className="ProfileCard-realName"></div>
              </div>
            </div>
          </script>
          <script id="empty-template" type="text/x-handlebars-template">
            <div className="EmptyMessage">
              {
                "Your search turned up 0 results. This most likely means the backend is down, yikes!"
              }
            </div>
          </script>
        </div>
        {openCalculator && (
          <FixedPlugin
            history={history}
            calculatorFlag={calculatorFlag}
            setHistory={setHistory}
            setCalculatorFlag={setCalculatorFlag}
          />
        )}
      </div>
    </Fragment>
  );
};
export default Header;
